import { api, query } from '@organization/api'
import { MFATrustedDevice } from '@organization/models'
import { showApiErrors } from '@shared/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App, Button, ButtonProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = { data: MFATrustedDevice } & ButtonProps

export const DeleteTrustedDevice = ({ data, ...props }: Props) => {
  const { t } = useTranslation()
  const { message, modal } = App.useApp()
  const queryClient = useQueryClient()

  const { mutateAsync: deleteTrustedDevice, isPending: isPendingDelete } =
    useMutation({
      mutationFn: api.mfa.deleteTrustedDevice,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [query.mfa.getTrustedDevices().queryKey[0]]
        })
        message.success(t('device_deleted'))
      },
      onError: (error) => showApiErrors(error)
    })

  const onDelete = () => {
    const id = data?.id
    if (!id) return

    modal.confirm({
      title: t('confirm_delete_device'),
      content: (
        <div
          dangerouslySetInnerHTML={{
            __html: t('confirm_delete_device_info', { name: data.device_name })
          }}
        />
      ),
      onOk: () => deleteTrustedDevice(id)
    })
  }

  return (
    <Button
      size="small"
      type="primary"
      loading={isPendingDelete}
      onClick={onDelete}
      {...props}
    >
      {t('button.delete')}
    </Button>
  )
}
